module.exports = __webpack_public_path__ + "img/test-place-order@2x.fc2fb5e5.png";